"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useAnimatingToEnd;

var _react = require("react");

var _StateContext = _interopRequireDefault(require("../ScrollToBottom/StateContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useAnimatingToEnd() {
  var context = (0, _react.useContext)(_StateContext.default);
  return [context.animatingToEnd];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VBbmltYXRpbmdUb0VuZC5qcyJdLCJuYW1lcyI6WyJ1c2VBbmltYXRpbmdUb0VuZCIsImNvbnRleHQiLCJTdGF0ZUNvbnRleHQiLCJhbmltYXRpbmdUb0VuZCJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOztBQUVBOzs7O0FBRWUsU0FBU0EsaUJBQVQsR0FBNkI7QUFDMUMsTUFBTUMsT0FBTyxHQUFHLHVCQUFXQyxxQkFBWCxDQUFoQjtBQUVBLFNBQU8sQ0FBQ0QsT0FBTyxDQUFDRSxjQUFULENBQVA7QUFDRCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IHVzZUNvbnRleHQgfSBmcm9tICdyZWFjdCc7XG5cbmltcG9ydCBTdGF0ZUNvbnRleHQgZnJvbSAnLi4vU2Nyb2xsVG9Cb3R0b20vU3RhdGVDb250ZXh0JztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gdXNlQW5pbWF0aW5nVG9FbmQoKSB7XG4gIGNvbnN0IGNvbnRleHQgPSB1c2VDb250ZXh0KFN0YXRlQ29udGV4dCk7XG5cbiAgcmV0dXJuIFtjb250ZXh0LmFuaW1hdGluZ1RvRW5kXTtcbn1cbiJdfQ==